import React from 'react'
import { CardShadowMain } from './styles'

export function CardShadow(props: any) {
  return (
    <CardShadowMain fluid>
      {props.children}
    </CardShadowMain>
  )
}